import { NgFor, NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatNativeDateModule } from '@angular/material/core'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { NgxPaginationModule } from 'ngx-pagination'
import { Incident } from '../../../models/incident.interface'
import { catchError, Observable, of, Subscription, switchMap, tap } from 'rxjs'
import { Pagination } from '../../../models/pagination.interface'
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser'
import { TrackingService } from '../../../services/tracking/tracking.service'
import { IncidentService } from '../../../services/incident/incident.service'
import { ToastrService } from 'ngx-toastr'
import { UploadfileService } from '../../../services/uploadfile/uploadfile.service'
import { AccompanimentFormComponent } from '../accompaniment-form/accompaniment-form.component'
import { Accompaniment } from '../../../models/accompaniment.interface'
import { AccompanimentService } from '../../../services/accompaniment/accompaniment.service'

@Component({
    selector: 'app-tracking-list-madeja',
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MatIcon,
        RouterLink,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        MatNativeDateModule,
    ],
    templateUrl: './accompaniment-list.component.html',
    styleUrl: './accompaniment-list.component.css',
})
export class AccompanimentListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    incident: string | null = null
    incidenteSeleccionado: Incident | null = null
    accompaniment: Accompaniment | null = null
    limit = 10
    total = 0
    asyncAccompaniment!: Observable<Pagination<Accompaniment[]>>
    accompanimentList: Accompaniment[] = []
    pagination: Pagination<any> | null = null

    showColumns: string[] = ['acciones', 'id', 'description', 'address', 'file']

    displayedColumns: string[] = [
        'id',
        'violenceType',
        'description',
        'witnesses',
        'location',
        'perpetror',
        'victim',
    ]

    private routeSubscription: Subscription | undefined

    constructor(
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private title: Title,
        private trackingService: TrackingService,
        private serviceAccompaniment: AccompanimentService,
        private incidentService: IncidentService,
        private toastr: ToastrService,
        private uploadfileService: UploadfileService
    ) {
        this.title.setTitle('Seguimientos')
    }

    ngOnInit(): void {
        this.fetchAccompaniment()
    }
    ngOnDestroy(): void {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe()
        }
    }

    fetchAccompaniment() {
        this.route.paramMap
            .pipe(
                switchMap((params) => {
                    const id = params.get('id')
                    if (id) {
                        this.incident = id
                        return this.incidentService.getById(id)
                    }
                    return []
                })
            )
            .subscribe((incident) => {
                this.accompanimentList = incident.accompaniment
                this.incidentService.setIncident(incident)
                this.incidenteSeleccionado = incident
                this.accompanimentList = incident.accompaniment
            })
    }

    createAccompaniment() {
        this.serviceAccompaniment.removeSelectedAccompaniment()
        const dialogRef = this.dialog.open(AccompanimentFormComponent, {
            width: '90vw',
            maxWidth: '95vw',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
            data: {
                isCreate: true,
                incidentId: this.incident,
            },
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchAccompaniment()
        })
    }

    editAccompaniment(accompaniment: Accompaniment) {
        this.serviceAccompaniment.setSelectedAccompaniment(accompaniment)
        const dialogRef = this.dialog.open(AccompanimentFormComponent, {
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
            panelClass: 'custom-dialog-container',
            data: {
                isCreate: false,
            },
        })

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fetchAccompaniment()
            }
        })
    }

    deleteAccompaniment(accompanimentId: number) {
        if (confirm('¿Seguro que deseas eliminar este seguimiento?')) {
            this.serviceAccompaniment
                .deleteAccompaniment(accompanimentId)
                .pipe(
                    tap(() => {
                        const successMsg = `Eliminado CORRECTAMENTE!`
                        this.toastr.success(successMsg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.fetchAccompaniment()
                    }),
                    catchError((err) => {
                        console.error('Error eliminando seguimiento:', err)
                        const successMsg = `NO se pudo eliminar!`
                        this.toastr.error(successMsg, 'Error!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        return of(null)
                    })
                )
                .subscribe()
        }
    }

    openFile(incident: Incident): void {
        const id = incident?.fileAttach?.fileUrl
        const name = incident?.fileAttach?.fileName || 'archivo'
        this.uploadfileService.openPdfById(id, name).subscribe({
            error: () => {
                const msg = `No se pudo descargar o previsualizar el archivo`
                this.toastr.error(msg, 'Error', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
        })
    }

    hasFile(incident: Incident) {
        return (
            !!incident?.fileAttach?.fileUrl && !!incident?.fileAttach?.fileName
        )
    }
}
